<template>
  <nav
    vertical
    :class="{ sidebar: true }"
    v-if="$route.path != '/login'"
    class="menu__mobile"
  >
    <header class="logo">
      <button v-b-toggle.sidebar-backdrop class="toggle-sidebar">
        <b-icon icon="list" class="open"></b-icon>
      </button>
    </header>
    <b-sidebar
      id="sidebar-backdrop"
      class="sidebar-wrapper__new"
      width="200px"
      backdrop
      shadow
      no-header
    >
      <header class="logo">
        <router-link to="/">
          <!--
                <img v-if="sidebarFull" src="./assets/logo/svg/caltrans-white.svg" class="logo img-fluid" alt="Caltrans Logo" />
                <img v-else src="./assets/logo/svg/caltrans-white-symbol.svg" class="logo img-fluid" alt="Caltrans Logo" />
                -->
          <img
            src="@/assets/logo/white-gla-logo.png"
            class="logo img-fluid"
            alt="GLA Logo"
          />
        </router-link>
      </header>
      <ul class="sidebar-nav">
        <li
          v-if="authenticated && isAdmin && !onMultipleProjects"
          class="menu-item"
        >
          <router-link to="/project">
            <b-icon icon="columns-gap"></b-icon>
            <span class="labelName">Project</span>
          </router-link>
        </li>
        <!-- <li v-if="authenticated && isAdmin" class="menu-item">
                <router-link to="/dashboard">
                  <b-icon icon="columns-gap"></b-icon>
                  <span class="labelName">Dashboard</span>
                </router-link>
              </li> -->
        <li v-if="authenticated && isSponsor" class="menu-item">
          <router-link to="/overview">
            <b-icon icon="columns-gap"></b-icon>
            <span class="labelName">Overview</span>
          </router-link>
        </li>
        <li
          v-if="
            authenticated && (systemAdmin || (onMultipleProjects && isAdmin))
          "
          class="menu-item menu-item-has-child"
        >
          <router-link to="/projects">
            <b-icon icon="view-stacked"></b-icon>
            <span class="labelName">Projects</span>
          </router-link>
          <!-- <ul v-if="sidebarFull" class="sub-menu">
                  <li class="menu-item">
                    <button>
                      <span class="labelName">Opened</span>
                    </button>
                  </li>
                  <li class="menu-item">
                    <button>
                      <span class="labelName">On Hold</span>
                    </button>
                  </li>
                  <li class="menu-item">
                    <button>
                      <span class="labelName">Closed</span>
                    </button>
                  </li>
                </ul> -->
        </li>
        <!--
              <li class="menu-item toggle">
                <router-link to="#">
                  <b-icon icon="envelope"></b-icon>
                </router-link>
              </li>-->
        <li v-if="authenticated && systemAdmin" class="menu-item off">
          <router-link to="/question-template/list">
            <b-icon icon="question-circle"></b-icon>
            <span class="labelName">Evaluations</span>
          </router-link>
        </li>
        <li v-if="authenticated && systemAdmin" class="menu-item off">
          <router-link to="/organization/list">
            <b-icon icon="people"></b-icon>
            <span class="labelName">Organizations</span>
          </router-link>
        </li>
        <li v-if="authenticated && systemAdmin" class="menu-item">
          <router-link to="/user/list">
            <b-icon icon="person"></b-icon>
            <span class="labelName">Users</span>
          </router-link>
        </li>
        <!--
              <li class="menu-item toggle">
                <router-link to="#">
                  <b-icon icon="chat-left"></b-icon>
                </router-link>
              </li>
              <li class="menu-item toggle">
                <router-link to="#">
                  <b-icon icon="layout-three-columns"></b-icon>
                </router-link>
              </li>-->
        <hr />
        <!--<li class="menu-item toggle">
                <button>
                  <b-icon icon="three-dots"></b-icon>
                </button>
              </li>-->
        <li v-if="authenticated" class="menu-item off">
          <a href="https://www.youtube.com/channel/UCP2m2CYU6Ln47IGKCuvNm_g">
            <b-icon icon="collection-play"></b-icon>
            <span class="labelName">Help</span>
          </a>
        </li>
        <li v-if="authenticated" class="menu-item off">
          <router-link to="/user/settings">
            <b-icon icon="gear"></b-icon>
            <span class="labelName">Settings</span>
          </router-link>
        </li>
        <li v-if="!authenticated" class="menu-item">
          <router-link to="/login">
            <b-icon icon="lock"></b-icon><span class="labelName">Login</span>
          </router-link>
        </li>
        <li v-if="authenticated" class="menu-item">
          <button @click.stop="logout">
            <b-icon icon="door-open"></b-icon>
            <span class="labelName">Logout</span>
          </button>
        </li>
      </ul>
      <div class="by">
        <p class="by-company">
          Powered by
          <img
            src="@/assets/logo/svg/dashtech-alt-logo.svg"
            alt="DashTech Logo"
            class="pb-logo"
          />
        </p>
      </div>
    </b-sidebar>
  </nav>
</template>

<script>
export default {
  name: "MobileNav",
  props: {
    authenticated: {
      type: Boolean,
      default: false,
    },
    isAdmin: {
      type: Boolean,
      default: false,
    },
    onMultipleProjects: {
      type: Boolean,
      default: false,
    },
    isSponsor: {
      type: Boolean,
      default: false,
    },
    systemAdmin: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    logout() {
      this.$authService.msal.setActiveAccount(null);
      this.$auth.clearSession().then(() => {
        this.$router.push({ name: "Login" });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>